module.exports = __webpack_public_path__ + "img/img-yingjian-s2.3b956018.jpg";